import React, { useCallback, useState } from 'react'
import {
    createColumnHelper,
    getCoreRowModel,
    useReactTable,
    getSortedRowModel
} from '@tanstack/react-table'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { Button, Dropdown, Form, InputGroup, Modal } from 'react-bootstrap'
import { Link, NavLink, useNavigate, useParams } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import ReactTable from '../../components/ReactTable'
import Pagination from '../../components/Pagination'
import requestApi from '../../utils/request'
import { formatDateToMonthShortwithFormate } from '../../functions/common'
import Swal from 'sweetalert2'
import { ReactComponent as Eyes } from '../../assets/images/teyes.svg'
import { ReactComponent as Edit } from '../../assets/images/tedit.svg'
import { ReactComponent as Delete } from '../../assets/images/tdelete.svg'
import { ReactComponent as DeleteImg } from '../../assets/images/redbin.svg'
import { ReactComponent as SearchIcon } from '../../assets/images/greysearch.svg'
import { ReactComponent as FilterIcon } from '../../assets/images/filter.svg'
import { employerview, createnewblog, viewblog, blogs } from '../../Routes/routingConsts'
import DropDownControl from '../../components/DropDownControl/DropDownControl'
import SpinnerLoader from '../../components/SpinnerLoader'
import { Spinner } from 'react-bootstrap'
import { useEffect } from 'react'
import { deleteActionIcon, viewIcon, editactionIcon } from '../../functions/actionIcons'
import FlottedButton from '../../components/FlottingButton'


function finaldata(){
    let a=0
    return ()=>{
        if (a>2) {
            a=0
        }
        return a++
    }
}
function finaldata2(){
    let b=0
    return ()=>{
        if (b>2) {
            b=0
        }
        return b++
    }
}

const z=finaldata()
const z2 = finaldata2()
const Blogs = () => {

     const[randomColor, setRendomColor] = useState(["#e295ee","#F7C873","#be6b78"])
     const[randomoutlineColor, setRendomoutlineColor] = useState(["#8c139f","#434343","#fff"])


    const navigate = useNavigate()
    const [toggle, setToggle] = useState(null)
    const queryClient = useQueryClient()
    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    console.log('currentPage===>',currentPage);
    console.log('DataLimit===>',DataLimit)
    // const [TotalPagies, setTotalPagies] = useState(1)
    const [userFilterText, setuserFilterText] = useState('')
    const handleChange2 = (e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setuserFilterText(e.target.value)
        }, 1000)
        clearInterval()
    }

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }

    function viewjobopeningData(blogId) {
        navigate(`${viewblog}/${blogId}`)
    }

    function editjobopening(blogId) {
        navigate(`${createnewblog}/${blogId}`)
    }

    /////status filter////
    const [statusControl, setStatusControl] = useState('')
    const handleChangeStatus = (eventKey) => {
        setCurrentPage(1)
        setStatusControl(eventKey)
    }
    ////end///
    const {
        register,
        handleSubmit,
        reset,
        getValues,
        control,
        formState: { errors }
    } = useForm()

    const [sorting, setSorting] = useState([])

    function UserList({ queryKey }) {
        return requestApi
            .post(
                `/blog/list`,
                {
                    search: queryKey[3],
                    limit: queryKey[2],
                    page: queryKey[1],
                    sortKey: queryKey[4]?.id ?? '',
                    sortBy: queryKey[4] ? (queryKey[4]?.desc ? -1 : 1) : '',
                    status: statusControl
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: [
            'jobOpeninglist',
            currentPage,
            DataLimit,
            userFilterText,
            sorting[0],
            statusControl
        ],
        queryFn: UserList
        // select: () => {
        //     return {
        //         data: null
        //     }
        // }
    })

    let totalJobOpening = data?.meta?.totalCount

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.display({
            id: 'actions',
            header: 'Action',
            cell: (row) => {
                return (
                    <>
                        <div className="">
                            <FlottedButton
                                clickFn={() => {
                                    setToggle((pre) =>
                                        pre === row.row.original?.blogId
                                            ? null
                                            : row.row.original?.blogId
                                    )
                                }}
                                isTrue={
                                    row.row.original?.blogId === toggle
                                }
                            >
                                {row.row.original.status === 3 ? (
                                    ''
                                ) : (
                                    <li
                                        className=" i1 icon"
                                        onClick={() =>
                                            viewjobopeningData(
                                                row.row.original?.blogId
                                            )
                                        }
                                    >
                                        {viewIcon}
                                    </li>
                                )}
                                <li
                                        className=" i1 icon"
                                        onClick={() =>
                                            editjobopening(
                                                row.row.original?.blogId
                                            )
                                        }
                                    >
                                        {editactionIcon}
                                    </li>
                                {/* <Link
                                    to={`/createnewopening/${row?.row?.original?.userId}`}
                                >
                                    <button
                                        className="action-btn"
                                        onClick={() =>
                                            editjobopening(
                                                row.row.original?.jobOpeningId
                                            )
                                        }
                                    >
                                        <span>
                                            <Edit />
                                        </span>
                                    </button>
                                </Link> */}
                                {row.row.original.status === 3 ? (
                                    ''
                                ) : (
                                    <li
                                        className=" i1 icon"
                                        onClick={() =>
                                            hanleDeleteModal(
                                                row.row.original?.blogId
                                            )
                                        }
                                    >
                                        {deleteActionIcon}
                                    </li>
                                )}
                            </FlottedButton>
                        </div>
                    </>
                )
            }
        }),
        columnHelper.accessor((row) => row.image, {
            id: 'image',
            header: 'Photo',
            enableSorting:false,
            cell: (row) => {
                // return <p>{row.row.original?.image}</p>
                return <img src={row.row.original?.image} />
            }
        }),
        columnHelper.accessor((row) => row.jobTitle, {
            id: 'blogTitle',
            header: 'Title',
            cell: (row) => {
                return <p>{row.row.original?.blogTitle}</p>
            }
        }),
        columnHelper.accessor((row) => row.tags, {
            id: 'tags',
            header: 'Tags',
            enableSorting:false,
            cell: (row) => {
                return (
                    <>
                    {
                        row?.row?.original?.tags?.map((tag,i)=>{
                         return(
                             <button className='custom-width'
                              style={{padding:"10px",margin:"3px", pointerEvents:"none",border:"none",
                              backgroundColor:"#814b99",
                              borderRadius:"10px",
                               color:"#fff"
                        }}
                               key={i}
                               >{tag}</button>
                         )

                    })
                    }
                    </>
                )
            }
        }),
        // columnHelper.accessor((row) => row.description, {
        //     id: 'description',
        //     header: 'Description',
        //     cell: (row) => {
        //         return <div dangerouslySetInnerHTML={{__html:row.row.original?.description}}></div> 
        //     }
        // }),
        // columnHelper.accessor((row) => row.conclusion, {
        //     id: 'conclusion',
        //     header: 'Conclusion',
        //     cell: (row) => {
        //         return (
        //             <p>
        //                 {row.row.original?.conclusion}
        //             </p>
        //         )
        //     }
        // }),
        
    ]

    // useEffect while record deleted on last page ////
    useEffect(() => {
        if (currentPage && data?.data?.length == 0) {
            setCurrentPage(1)
        } else {
        }
    }, [currentPage, data?.data])

    // End useEffect ////

    const tableInstance = useReactTable({
        data: data?.data,
        columns: columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    // Delete User

    const [showDelete, setShowDelete] = useState(false)
    const [deletedId, setDeletedId] = useState(null)

    async function deleteJobOpeningId(blogId) {
        return await requestApi.post(`/blog/delete`, {
            blogId
        })
    }
    const mutationDelete = useMutation(deleteJobOpeningId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('jobOpeninglist')
            setShowDelete(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })

    const hanleDeleteModal = (blogId) => {
        setShowDelete(true)
        setDeletedId(blogId)
    }
    const handleDeleteUser = (blogId) => {
        mutationDelete.mutate(blogId)
        setShowDelete(false)
    }

    return (
        <>
            <div className="sidebar-content common-page">
                <div className="contentwhole-box">
                    <div className="filter-titlebox">
                        <div className="title-text">
                            <h3>Manage Blogs</h3>
                        </div>
                        <div className="filterbox">
                            <div className="searcskills myaccount-page">
                                <div>
                                    <div className="searchstatus-box">
                                        <InputGroup className="mb-3 input-wrapper">
                                            <InputGroup.Text id="basic-addon1">
                                                <SearchIcon />
                                            </InputGroup.Text>
                                            <Form.Control
                                                placeholder="Search"
                                                type="search"
                                                aria-label="Username"
                                                aria-describedby="basic-addon1"
                                                className="icontrol"
                                                {...register(
                                                    'jobOpeningSearch',
                                                    {
                                                        onChange: (e) => {
                                                            handleChange2(e)
                                                        }
                                                    }
                                                )}
                                            />
                                        </InputGroup>
                                        <NavLink
                                            to={createnewblog}
                                                className="common-btn save-btn"
                                                style={{padding: '14px', marginLeft: '15px', width: '100%'}}
                                                state="Create New Opening"
                                            >
                                            + Create New Blog
                                        </NavLink>
                                        {/* <div className="status-dropdown">
                                            <Dropdown
                                                placeholder="Status"
                                                onSelect={handleChangeStatus}
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {!!statusControl
                                                        ? statusControl
                                                        : 'Job Status'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="">
                                                        Job Status
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="Active">
                                                        Active
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="Inactive">
                                                        Inactive
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="Archived">
                                                        Archived
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            {/* dashboard drop down */}

                            {/* <div className="title-text">
                        <h5>Job Status</h5>
                        <div className="chartlist">
                            <Dropdown
                                className="week-dropdown"
                                flip="no"
                                onSelect={handleChangeStatus}
                            >
                                <Dropdown.Toggle id="dropdown-basic">
                                    
                                    {statusControl}
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="dropdown-content">
                                    <Dropdown.Item eventKey="Active">
                                        Active
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey="Inactive">
                                        Inactive
                                    </Dropdown.Item>
                                    <Dropdown.Item eventKey="Archived">
                                        Archived
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div> */}
                            {/* end dropdown */}

                            {/* </div> */}
                        </div>
                    </div>

                    {isLoading ? (
                        <div className="spinner-wrapper">
                            <Spinner
                                animation="border"
                                role="status"
                                className="tdata"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        </div>
                    ) : (
                        <>
                            {' '}
                            {data?.data?.length > 0 ? (
                                <>
                                    <ReactTable tableInstance={tableInstance} />
                                    <div className="paginationbox">
                                        <div className="showingpages">
                                            <span>
                                                Showing{' '}
                                                {(currentPage - 1) * DataLimit +
                                                    1}{' '}
                                                to{' '}
                                                {Math.min(
                                                    currentPage * DataLimit,
                                                    totalJobOpening
                                                )}{' '}
                                                of {totalJobOpening} Blogs
                                            </span>
                                        </div>
                                        {totalJobOpening > 10 && <div className="itemsperpage">
                                            <span>Items per page:</span>
                                            <Dropdown
                                                flip="no"
                                                onSelect={handleChange}
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {DataLimit}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="10">
                                                        10
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="20">
                                                        20
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="30">
                                                        30
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>}
                                        {totalJobOpening > 10 && (
                                            <div className="pagination">
                                                <Pagination
                                                    total={Math.ceil(
                                                        totalJobOpening /
                                                            DataLimit
                                                    )}
                                                    current={currentPage}
                                                    onChangePage={
                                                        handleChangePage
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div className="noresult">
                                    <p>No Result Found</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <Modal
                className="modalbox deletemodal"
                show={showDelete}
                onHide={() => setShowDelete(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Form className="formbox">
                        <div className="delete-box">
                            <div className="deleteimg">
                                <DeleteImg />
                            </div>
                            <div className="content">
                                <h4>
                                    Are you sure you want to delete this <br />
                                    Blog?
                                </h4>
                            </div>
                            <div className="delete-action">
                                <button
                                    className="common-btn yes"
                                    type="button"
                                    onClick={() => handleDeleteUser(deletedId)}
                                >
                                    Yes
                                </button>
                                <button
                                    className="common-btn no"
                                    type="button"
                                    onClick={() => setShowDelete(false)}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Blogs;
